<ng-container *transloco="let t">
  <div *ngIf="contentType === SETTINGS.CONTENT_TYPES.TYPED">
    <form [formGroup]="descriptionForm">
      <nz-form-item class="lg:flex">
        <nz-form-control [nzErrorTip]="keywordCheck">
          <input
            nz-input
            formControlName="keyword"
            [placeholder]="t('sharedContent.addDescription.typed.keywordPlaceholder')" />
        </nz-form-control>
        <ng-template #keywordCheck></ng-template>
      </nz-form-item>

      <nz-form-item class="lg:flex">
        <nz-form-control [nzErrorTip]="descriptionCheck">
          <quill-editor
            class="w-full h-52"
            formControlName="body"
            [placeholder]="t('sharedContent.addDescription.typed.descriptionPlaceholder')">
            <div quill-editor-toolbar>
              <div class="ql-formats">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
              </div>
            </div>
          </quill-editor>
        </nz-form-control>
        <ng-template #descriptionCheck></ng-template>
      </nz-form-item>

      <div class="text-end">
        <button
          nz-button
          nzType="primary"
          (click)="submit()"
          [disabled]="descriptionForm.invalid">
          {{
            description
              ? t('sharedContent.addDescription.typed.editBtn')
              : t('sharedContent.addDescription.typed.addBtn')
          }}
        </button>
      </div>
    </form>
  </div>

  <div *ngIf="contentType === SETTINGS.CONTENT_TYPES.GENERATED">
    <nz-form-item class="lg:flex">
      <nz-form-label class="text-start">
        {{ t('sharedContent.addDescription.generated.keywordsLabel') }}
      </nz-form-label>
      <nz-form-control>
        <nz-select
          nzMode="tags"
          [nzPlaceHolder]="t('sharedContent.addDescription.generated.keywordsPlaceholder')"
          [nzShowArrow]="true"
          nzAllowClear
          [(ngModel)]="chatKeywords">
          <nz-option
            *ngFor="let option of keyword; let i = index"
            [nzLabel]="option"
            [nzValue]="option"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <div class="flex flex-row gap-10">
      <nz-form-item>
        <nz-form-label class="text-start">
          {{ t('sharedContent.addDescription.generated.minWordsLabel') }}
        </nz-form-label>
        <nz-form-control>
          <input
            nz-input
            type="number"
            name="minWords"
            [(ngModel)]="minWords"
            [placeholder]="t('sharedContent.addDescription.generated.minWordsPlaceholder')"
            #minWordsRef="ngModel"
            [min]="40"
            [max]="100" />
          <ng-container *ngIf="minWordsRef.invalid">
            <div *ngIf="minWordsRef.errors?.['required']">
              {{ t('sharedContent.addDescription.generated.minWordsRequired') }}
            </div>
            <div *ngIf="minWordsRef.errors?.['min']">
              {{ t('sharedContent.addDescription.generated.minWordsMin') }}
            </div>
            <div *ngIf="minWordsRef.errors?.['max']">
              {{ t('sharedContent.addDescription.generated.minWordsMax') }}
            </div>
          </ng-container>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label class="text-start">
          {{ t('sharedContent.addDescription.generated.maxWordsLabel') }}
        </nz-form-label>
        <nz-form-control>
          <input
            nz-input
            type="number"
            name="maxWords"
            [(ngModel)]="maxWords"
            #maxWordsRef="ngModel"
            [placeholder]="t('sharedContent.addDescription.generated.maxWordsPlaceholder')"
            required
            [min]="minWords"
            max="500" />
          <ng-container *ngIf="maxWordsRef.invalid" class="error">
            <div *ngIf="maxWordsRef.errors?.['required']">
              {{ t('sharedContent.addDescription.generated.maxWordsRequired') }}
            </div>
            <div *ngIf="maxWordsRef.errors?.['min']">
              {{ t('sharedContent.addDescription.generated.maxWordsMin') }} ({{ minWords }}).
            </div>
            <div *ngIf="maxWordsRef.errors?.['max']">
              {{ t('sharedContent.addDescription.generated.maxWordsMax') }}
            </div>
          </ng-container>
        </nz-form-control>
      </nz-form-item>
    </div>

    <nz-divider nzType="horizontal"></nz-divider>

    <nz-spin [nzSize]="'small'" [nzSpinning]="isLoading">
      <ng-container *ngIf="isData">
        <p>{{ descriptionForm.controls.body.value }}</p>
        <br />
        <p class="font-bold">
          {{ t('sharedContent.addDescription.generated.keywordsPreview') }}
          {{ descriptionForm.controls.keyword.value }}
        </p>
      </ng-container>
    </nz-spin>

    <div class="mt-3 flex justify-end">
      <button
        class="mr-3 ai-button flex items-center"
        nz-button
        nzType="default"
        (click)="reGenerate()">
        <span *ngIf="isData" nz-icon nzType="redo" nzTheme="outline"></span>
        {{
          !isData
            ? t('sharedContent.addDescription.generated.generateBtn')
            : t('sharedContent.addDescription.generated.regenerateBtn')
        }}
      </button>
      <button
        nz-button
        nzType="primary"
        (click)="submit()"
        [disabled]="descriptionForm.invalid">
        {{
          description
            ? t('sharedContent.addDescription.generated.editBtn')
            : t('sharedContent.addDescription.generated.addBtn')
        }}
      </button>
    </div>
  </div>
</ng-container>